import React from 'react';
import styled from 'styled-components';
import t from 'prop-types';

const TabBarContainer = styled.div`
  display: flex;
`;

const Tab = styled.div`
  display: flex;
  align-items: center;
  margin-right: 32px;
  padding-bottom: 4px;
  cursor: pointer;
  font-size: 14px;
  border-bottom: 2px solid
    ${props => (props.isSelected ? props.theme.colors.primary : 'transparent')};
  font-weight: ${props => props.isSelected && 'bold'};
  opacity: ${props => props.disabled && 0.2};
  text-transform: uppercase;
`;

class TabBar extends React.Component {
  selectTab = (tab, index) => {
    const {onSelect = () => {}} = this.props;
    onSelect(tab, index);
  };

  render() {
    const {tabs, style, selected} = this.props;
    return (
      <TabBarContainer style={style}>
        {tabs.map((tab, i) => (
          <Tab
            key={tab.title}
            onClick={() => !tab.disabled && this.selectTab(tab, i)}
            isSelected={i === selected}
            disabled={tab.disabled}
          >
            {tab.title}
          </Tab>
        ))}
      </TabBarContainer>
    );
  }
}

TabBar.propTypes = {
  tabs: t.array,
  onSelect: t.func,
  selected: t.number,
  style: t.object,
};

export default TabBar;
